import React from 'react';

import { Text } from '../text/text';
import './label.scss';

type LabelProps = {
  color?: string;
  size?: 'x-small' | 'small' | 'medium' | 'large';
};

export const Label: React.FC<LabelProps> = ({ color, size, children }) => {
  return (
    <div className="bd-label" style={{ background: color }}>
      <Text size={size}>{children}</Text>
    </div>
  );
};
